var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg6C8B774D5B4Eac2D6Cd6C783318D7352(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "420px",
    height: "420px",
    viewBox: "0 0 420 420",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Luovuus-tarppo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Luovuus-tarppo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ribbon-center",
    transform: "translate(60.000000, 165.000000)",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeWidth: 28
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 62,
    y: 16,
    width: 174,
    height: 70
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Line",
    strokeLinecap: "square",
    points: "62 60 0 60 15.888356 30 0 0 62 0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(236.000000, 0.000000)",
    strokeLinecap: "square"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Line",
    transform: "translate(31.000000, 30.000000) scale(-1, 1) translate(-31.000000, -30.000000) ",
    points: "62 60 0 60 15.888356 30 0 0 62 0"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M210,419 C94.5722857,419 1,325.427714 1,210 C1,94.5722857 94.5722857,1 210,1 C325.427714,1 419,94.5722857 419,210 C419,325.427714 325.427714,419 210,419 Z",
    id: "Fill-17",
    fill: "#5E0F75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.436189,167.077797 L253.563811,167.077797 L253.563811,121.221154 L166.436189,121.221154 L166.436189,167.077797 Z M186.097642,307.483507 L209.69517,318.855844 L233.960419,306.507087 L210.023879,196.288836 L186.097642,307.483507 Z M234.966453,192.298951 L262.73514,320.162713 L210,347 L157.26486,321.585399 L185.083982,192.298951 L141.215035,192.298951 L141.215035,96 L278.784965,96 L278.784965,192.298951 L234.966453,192.298951 Z",
    id: "Brush",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg6C8B774D5B4Eac2D6Cd6C783318D7352);
export default __webpack_public_path__ + "static/media/6c8b774d5b4eac2d6cd6c783318d7352.0fd2ece6ea4ec002059f4adf429c361b.svg";
export { ForwardRef as ReactComponent };